export const ROLE_LIVE_EMAIL_LABEL = '"Your role is live" email';

export const HIRING_TEAM_MEMBER_ADDED_EMAIL_LABEL =
  '"You\'ve been added as a hiring team member" email';

export const NOTIFICATIONS_DATA_TEST_ID = 'notifications-form';
